import React from 'react';
import {styles} from './styles.web';
import {ChipProps} from './Chip.types.web';
import {
  getChipGeneralStyles,
  getChipTextStyles,
  leadingIconMap,
  trailingIconMap,
} from './Chip.config.web';
import {useTheme} from '../../../../utils/theming/themeProvider';
import Tooltip from '../../Tooltips/Tooltip/Tooltip.web';

const Chip = (props: React.PropsWithChildren<ChipProps>) => {
  // Props
  const {
    id,
    className,
    color = 'grey',
    state = 'enable',
    style = 'filled',
    form = 'square',
    chipSize = 'medium',
    leadingIcon,
    trailingIcon,
    showText = true,
    text = 'Hello chip',
    tooltip,
    containerStyle,
  } = props;

  // Chip Styles
  const {colors, fontStyles} = useTheme();
  const chipStyles = getChipGeneralStyles(
    colors,
    color,
    style,
    state,
    form,
    chipSize,
  );
  const chipFontStyle = getChipTextStyles(
    fontStyles,
    colors,
    color,
    style,
    state,
    chipSize,
  );
  const containerStyles = styles();
  // Chip Icons
  const LeadingIconComponent = leadingIcon && leadingIconMap[leadingIcon];
  const TrailingIconComponent = trailingIcon && trailingIconMap[trailingIcon];

  return tooltip ? (
    <Tooltip {...tooltip} id={id} className={className}>
      <div
        style={{
          ...containerStyles.chipContainer,
          ...chipStyles,
          ...containerStyle,
        }}>
        {leadingIcon && LeadingIconComponent && (
          <div style={{...containerStyles?.iconContainer}}>
            <LeadingIconComponent size={'16'} color={chipStyles.textColor} />
          </div>
        )}
        {showText && text && (
          <p
            style={{
              ...chipFontStyle,
              lineHeight: chipFontStyle.lineHeight + 'px',
              margin: 0,
            }}>
            {text}
          </p>
        )}
        {trailingIcon && TrailingIconComponent && (
          <div style={{...containerStyles?.iconContainer}}>
            <TrailingIconComponent size={'16'} color={chipStyles.textColor} />
          </div>
        )}
      </div>
    </Tooltip>
  ) : (
    <div
      id={id}
      className={className}
      style={{
        ...containerStyles.chipContainer,
        ...chipStyles,
        ...containerStyle,
      }}>
      {leadingIcon && LeadingIconComponent && (
        <div style={{...containerStyles?.iconContainer}}>
          <LeadingIconComponent size={'16'} color={chipStyles.textColor} />
        </div>
      )}
      {showText && text && (
        <p
          style={{
            ...chipFontStyle,
            lineHeight: chipFontStyle.lineHeight + 'px',
            margin: 0,
          }}>
          {text}
        </p>
      )}
      {trailingIcon && TrailingIconComponent && (
        <div style={{...containerStyles?.iconContainer}}>
          <TrailingIconComponent size={'16'} color={chipStyles.textColor} />
        </div>
      )}
    </div>
  );
};

export default Chip;
